import Store from 'store/store'
import * as Opentype from 'opentype.js'

export default {
  fonts: async () => {
    // Load all fonts inside the Store.fonts key
    const fonts = Store.poster.fonts.get()
    for (const id in fonts) {
      const font = fonts[id]
      if (!font.url) throw new Error(`Font ${id} does not have a URL property`)

      Store.poster.fonts.current[id] = await new Promise(resolve => {
        Opentype.load(font.url, (error, font) => {
          if (error) throw error
          font.id = id
          resolve(font)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/preload.js